import { render, staticRenderFns } from "./Candidates.vue?vue&type=template&id=f11af54c&"
import script from "./Candidates.vue?vue&type=script&lang=js&"
export * from "./Candidates.vue?vue&type=script&lang=js&"
import style0 from "./Candidates.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Candidates.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f11af54c')) {
      api.createRecord('f11af54c', component.options)
    } else {
      api.reload('f11af54c', component.options)
    }
    module.hot.accept("./Candidates.vue?vue&type=template&id=f11af54c&", function () {
      api.rerender('f11af54c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/candidates/Candidates.vue"
export default component.exports